// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1m-7";
export var adjustableWidthBorderHeld = "_1m-8";
export var arrow = "_1m-3";
export var arrowButton = "_1m-4";
export var headerCell = "_1m-0";
export var help = "_1m-2";
export var icon = "_1m-1";
export var iconWrapper = "_1m-6";
export var noBorder = "_1m-b";
export var nonAdjustableWidthBorder = "_1m-9";
export var nonAdjustableWidthBorderHeld = "_1m-a";
export var textButton = "_1m-5";